import React from 'react';

function InfoBoxHeaderBlock (props) {
	return (
		<div></div>
	);
}

export default InfoBoxHeaderBlock;